namespace $ { $mol_style_attach( "mol/check/icon/icon.view.css",
 "[mol_check_icon][mol_check_checked] {\n\tcolor: var(--mol_theme_current);\n}\n"
) }